module.exports = __webpack_public_path__ + "img/screen-with-statistic.7c5a847c.svg";